export const ACCEPTED_SHAPEFILES = [
  '.kml',
  'application/vnd.google-earth.kml',
  '.zip',
  'application/zip',
  '.kmz',
  'application/vnd.google-earth.kmz',
  '.ndjson',
  'application/x-ndjson',
].join(',')

export const MAX_SHAPEFILE_SIZE = 20 * 1024 * 1024
